/**
 * ExpressionEnum
 * An enumeration.
 */
// TODO: Уточнить что это за ENUM у Бэка
export enum ExpressionEnum {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}